import React from 'react';

// Components
import Mappings from 'components/Mappings';

import { Prompt } from 'react-router';

// Styles
import withStyles from '@material-ui/core/styles/withStyles';
import { defineStyles, Classes } from 'styles/defineStyles';

const styles = defineStyles(theme => {
  return {
    root: {
      marginBottom: 350, // Needed for autosuggest overflow
    },
  };
});

interface Props {
  source: any;
  dirty?: boolean;
  classes: Classes<typeof styles>;
  setMappings: (batchActions: any[]) => void;
  setDirty: (dirty: boolean) => void;
}

function MappingsForm({ source, dirty, classes, setMappings, setDirty }: Props) {
  return (
    <div className={classes.root}>
      <Mappings setMappings={setMappings} source={source} setDirty={setDirty} />
      <Prompt
        when={dirty}
        message="Your mapping changes will not be saved. Are you sure you want to continue?"
      />
    </div>
  );
}

export default withStyles(styles)(MappingsForm);
